import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ITypicalErrorObject } from "@shared/components/interfaces/typical-error.interface";
import { TYPICAL_ERROR_ENUM } from "@shared/enums/typical-error.enum";

@Component({
  selector: 'app-typical-error',
  templateUrl: './typical-error.component.html',
  styleUrls: ['./typical-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypicalErrorComponent {
  public TYPICAL_ERROR_ENUM = TYPICAL_ERROR_ENUM;

  @Input() typicalErrorList: ITypicalErrorObject[];
}
